import { isNil, useControllableState, useEventCallback } from "../../shared";
// The shape is generic since ToggleButton and ToggleIconButton don't allow the same shapes. The output type of useToggleButton
// must forward the exact shape type as the one received in the parameters.
export function useToggleButton({
  active,
  checked,
  defaultChecked,
  forwardedRef,
  isCheckable,
  onChange,
  onCheck,
  shape,
  value,
  variant
}) {
  const [isChecked, setIsChecked] = useControllableState(checked, defaultChecked, false);
  const handleClick = useEventCallback(event => {
    setIsChecked(!isChecked);

    if (!isNil(onCheck)) {
      onCheck(event, value);
    }

    if (!isNil(onChange)) {
      onChange(event, !isChecked);
    }
  });
  return {
    buttonProps: {
      active: active || isChecked,
      onClick: handleClick,
      ref: forwardedRef,
      shape,
      value,
      [isCheckable ? "aria-checked" : "aria-pressed"]: isChecked,
      variant: variant
    },
    isChecked
  };
}